import VMasker from 'vanilla-masker/lib/vanilla-masker';
import FileListItem from '../../utils/file-list';
// import { observable } from 'mobx'
import axios from 'axios';
import jsonp from 'jsonp';
import { API_PATH, BASE_PATH, EMAIL_REGEX } from '../../constants'
import { setTimeout } from 'timers';


(() => {

  let urlParams = new URL(window.location.href);
  let selectedFiles = {};
  let product_id = urlParams.searchParams.get('productId');
  let action = urlParams.searchParams.get('action');
  let uf = urlParams.searchParams.get('uf');

  let contactData = {
    type: "contato",
    name: "",
    email: "",
    phone: "",
    origin: "",
    area: "",
    zipcode: "",
    maps_url: "",
    owner: null,
    product_id: product_id,
    product_name: '',
    uf: ((uf != null) ? uf : window.state),
    chat_url: ''
  };

  // console.log('contactData :: ', contactData);

  // let contactData = {
  //     name:"Julio",
  //     email:"julio@santa.io",
  //     phone:"14989898898",
  //     area:"50000",
  //     zipcode:"189000000",
  //     maps_url:"123123123",
  //     owner:true
  // }

  let historyIndexes = [0];
  let stepControllers = [];
  let prevButton = document.getElementById('prev-button');
  let nextButton = document.getElementById('next-button');

  // Mask
  const inputHandler = (masks, max, event) => {
    let c = event.target;
    let v = c.value.replace(/\D/g, '');
    let m = c.value.length > max ? 1 : 0;
    VMasker(c).unMask();
    VMasker(c).maskPattern(masks[m]);
    c.value = VMasker.toPattern(v, masks[m]);
  };

  let telMask = ['(99) 9999-99999', '(99) 99999-9999'];
  let tel = document.querySelector('#contact-phone');
  let tel2 = document.querySelector('#contact-phone-comprar');
  let cep = document.getElementById('cep');

  VMasker(tel).maskPattern(telMask[0]);
  VMasker(tel2).maskPattern(telMask[1]);

  VMasker(cep).maskPattern('99999-999');

  tel.addEventListener('input', inputHandler.bind(undefined, telMask, 14), false);

  const changeScreen = (toStep, buttonId, ignoreHistory) => {
    // Dispose on the Current Step Controller
    const currentStepController = stepControllers[historyIndexes[historyIndexes.length - 1]];
    if (currentStepController) currentStepController.map(ctrl => (ctrl.dispose()))
    // History Registration
    if (!ignoreHistory) historyIndexes.push(toStep);
    // console.log('>>> History :: ', historyIndexes);
    // Next Step Controller Initialization
    if (stepControllers[toStep]) stepControllers[toStep].map(ctrl => (ctrl.init()))

    // Navigation Buttons 
    //prevButton.disabled = toStep > 0 ? false : true;



    prevButton.disabled = false;

    switch (toStep) {
      case 0:
        prevButton.disabled = true;
        break;

      case "opcoes":
        nextButton.disabled = true;
        break;

      case "1.3":
      case 2:
        prevButton.style.display = 'none';
        nextButton.style.display = 'none';
        break;

      case 3:
        prevButton.style.display = 'none';
        nextButton.style.display = 'none';
        break;

      case "4.7":
        // (ok, direcionar agora)
        /*if (buttonId === 'sobre-financiamento') {
            document.getElementById('screen5').querySelector('.title-a').style.display = 'none';
            document.getElementById('screen5').querySelector('.title-b').style.display = 'block';
        }

        if (buttonId === 'trabalhar-cury') {
            document.getElementById('screen2').querySelector('.title-a').style.display = 'none';
            document.getElementById('screen2').querySelector('.title-b').style.display = 'block';
        }*/

        // prevButton.disabled = true;
        // nextButton.disabled = true;
        prevButton.style.display = 'none';
        nextButton.style.display = 'none';
        break;
    }

    document.body.classList.add('changing-chat-screen');

    window.setTimeout(() => {
      document.body.classList.remove('changing-chat-screen');

      const screens = document.getElementsByClassName('contact-screens-item active');
      const btns = document.getElementsByClassName('contact-cta');

      while (screens[0]) {
        screens[0].classList.remove('active');
      }

      let target = document.querySelector(`[data-screen="${toStep}"]`);

      if (buttonId) target.dataset.buttonId = buttonId;
      target.classList.add('active');

    }, 200);
  };

  window.addEventListener('DOMContentLoaded', () => {
    Array
      .prototype
      .slice
      .call(document.querySelectorAll('.form-control'))
      .map(element => {

        //let product_id = urlParams.searchParams.get('productId');

        let screenIndex = element.parentElement.parentElement.dataset.screen;
        if (!stepControllers[screenIndex]) stepControllers[screenIndex] = [];

        // console.log(action);
        // console.log(element.id);

        switch (element.id) {
          case 'contact-name':
            if (action == 'ofereca-terreno')
              stepControllers[screenIndex].push(new InputController(screenIndex, element, 4));
            else
              stepControllers[screenIndex].push(new InputController(screenIndex, element, "opcoes"));


            break;

          case 'comprar':
            stepControllers[screenIndex].push(new ButtonController(screenIndex, element, 1));
            break;

          case 'contact-email-comprar':
            stepControllers[screenIndex].push(new InputController(screenIndex, element, "1.1"));
            break;

          case 'contact-phone-comprar':
            stepControllers[screenIndex].push(
              new InputController(screenIndex, element,
                ((product_id == null) ? "1.2" : "1.3")
              )
            );
            break;

          case 'contact-region':
            stepControllers[screenIndex].push(new SelectController(screenIndex, element, "1.3"));
            break;

          case 'trabalhar-cury':
            stepControllers[screenIndex].push(new ButtonController(screenIndex, element, 2));
            break;
          case 'financeiro':
          case 'pos-vendas':
            stepControllers[screenIndex].push(new ButtonController(screenIndex, element, 3));
            break;

          case 'vender':
            stepControllers[screenIndex].push(new ButtonController(screenIndex, element, 4));
            break;

          case 'contact-email':
            stepControllers[screenIndex].push(new InputController(screenIndex, element, "4.1"));
            break;

          case 'contact-phone':
            stepControllers[screenIndex].push(new InputController(screenIndex, element, "4.2"));
            break;
          case 'area-terreno':
            stepControllers[screenIndex].push(new InputController(screenIndex, element, "4.3"));
            break;
          case 'cep':
            stepControllers[screenIndex].push(new InputController(screenIndex, element, "4.4"));
            break;

          case 'enviar-link-maps':
            stepControllers[screenIndex].push(new InputController(screenIndex, element, "4.5"));
            break;
          case 'nao-enviar-link-maps':
            stepControllers[screenIndex].push(new ButtonController(screenIndex, element, "4.5"));
            break;

          case 'escolher-imagens':
            stepControllers[screenIndex].push(new FileSelectorController(screenIndex, element, 'enviar-imagens'))
            break;
          case 'enviar-imagens':
            stepControllers[screenIndex].push(new FilesSenderController(screenIndex, element, 'images', "4.6", 'escolher-imagens'))
            break;
          case 'nao-possui-imagem':
            stepControllers[screenIndex].push(new FilesSenderController(screenIndex, element, 'images', "4.6"))
            break;

          case 'sou-proprietario':
          case 'sou-representante':
            stepControllers[screenIndex].push(new ButtonController(screenIndex, element, "4.7"));
            break;

          case 'voltar-site':
            element.addEventListener('click', e => {
              window.location = '/';
            })
            break;
          case 'parcerias-cury':
            element.addEventListener('click', e => {
              const lastStepButtonIdSelected = document.getElementById(`screen${historyIndexes[historyIndexes.length - 2]}`).dataset.buttonId;

              if (lastStepButtonIdSelected && lastStepButtonIdSelected == 'represento-imobiliaria') {
                postRequest('/realestate', contactData, () => {
                  // window.open('https://cury.net/imobiliarias', '_blank');
                  // window.location = 'https://cury.net/imobiliarias';

                  let urlImobiliarias = null;
                  if (window.state === "RJ") {
                    urlImobiliarias = 'https://curyconstrutorarj.hypnoboxparcerias.com.br/';
                  } else if (window.state === "SP" || window.state === "CAMPINAS") {
                    urlImobiliarias = 'https://curyconstrutora.hypnoboxparcerias.com.br/';
                  } else {
                    urlImobiliarias = 'https://cury.net/imobiliarias';
                  }

                  window.open(urlImobiliarias, '_blank');

                }, false)
              } else {
                // window.open('https://cury.net/imobiliarias', '_blank');
                window.location = 'https://cury.net/imobiliarias';
              }

            })
            break;

          case 'direcionar-chat-house':
            element.addEventListener('click', e => {
              // window.sendLead(contactData.product_id, contactData.name, contactData.email, extractDDD(contactData.phone), extractPhone(contactData.phone));
              GTM('gaTriggerEvent', 'conversao', 'chat', 'corretor_online');
              //window.startChat(contactData);
              // window.startChat(contactData);

              window.location.href = BASE_PATH;
            })
            break;


          case 'vagas-cury':
            element.addEventListener('click', e => {
              window.open('https://cury.gupy.io/', '_blank');
              window.location = '/';
            })
            break;

          case 'financeiro-link':
            element.addEventListener('click', e => {
              window.open('https://cury.force.com/portaldocliente/PortalLogin', '_blank');
              window.location = '/';
            })
            break;

          case 'direcionar-portal-cury':
            element.addEventListener('click', e => {
              window.open('http://www.relacionamentocury.com.br/', '_blank');
              window.location = '/';
            })
            break;
        }
      })

    // Step 0 Initialization
    stepControllers[0][0].init();

    prevButton.addEventListener('click', e => {
      changeScreen(historyIndexes[historyIndexes.length - 2], null, true);
      historyIndexes = historyIndexes.slice(0, -1);
    })

    nextButton.addEventListener('click', goNextStep)

    function goNextStep() {
      let currentStep = stepControllers[historyIndexes[historyIndexes.length - 1]];
      currentStep[0].nextStep();
    }

    //Function validate email
    async function validateEmail(email) {
      let res = fetch(`api/verify-email/${email}`).then(response => {
        return response.json();
      }).then(data => {
        return data.success;
      });

      return res;

      // const request = new XMLHttpRequest();
      // request.open('GET', `api/verify-email/${email}`, false);
      // request.send(null);

      // if (request.status === 200) {
      //     return JSON.parse(request.response)
      // } else {
      //     return true;
      // }
    }

    //Function validatePhone
    async function validatePhone(phone) {
      let res = fetch(`api/verify-phone/${phone}`).then(response => {
        return response.json();
      }).then(data => {
        return data.success;
      });

      return res;

      // const request = new XMLHttpRequest();
      // request.open('GET', `api/verify-phone/${phone}`, false);
      // request.send(null);

      // return JSON.parse(request.response)
    }

    // Step Controllers
    function InputController(index, element, goToStepIndex) {

      // console.log('InputController : index ', index);

      let self = this;
      self.index = parseInt(index);
      self.element = element;
      self.elementId = element.id;
      self.goToStepIndex = goToStepIndex;


      let keyUpHandler = (event) => {
        const value = document.getElementById('contact-name').value;

        nextButton.disabled = !isValid();

        if (event.keyCode === 13) { self.nextStep(); }

        Array.prototype.slice
          .call(document.querySelectorAll('.contact-user-name'))
          .map(item => item.innerHTML = value);
      }

      if (self.elementId === 'contact-email-comprar') {
        document.getElementById('lead_optin_email').addEventListener('change', function (e) {
          nextButton.disabled = !isValid();
        });
      }

      if (self.elementId === 'contact-email') {
        document.getElementById('terrain_optin_email').addEventListener('change', function (e) {
          nextButton.disabled = !isValid();
        });
      }

      if (self.elementId === 'contact-phone-comprar') {
        ['lead_optin_tel', 'lead_optin_sms', 'lead_optin_whatsapp'].forEach(function (elem) {
          document.getElementById(elem).addEventListener('change', function (e) {
            nextButton.disabled = !isValid();
          });
        });
      }

      if (self.elementId === 'contact-phone') {
        ['terrain_optin_tel', 'terrain_optin_sms', 'terrain_optin_whatsapp'].forEach(function (elem) {
          document.getElementById(elem).addEventListener('change', function (e) {
            nextButton.disabled = !isValid();
          });
        });
      }

      const isValid = () => {
        let value = false;
        let elValue = document.getElementById(self.elementId).value;
        //console.log(self.elementId);

        switch (self.elementId) {
          case 'contact-name':
            value = elValue.length ? true : false;
            contactData[self.elementId.split('contact-')[1]] = elValue;
            break;

          case 'contact-email':
            value = EMAIL_REGEX.test(String(elValue).toLowerCase());
            value = value && document.getElementById('terrain_optin_email').checked
            contactData['email'] = elValue;
            break;

          case 'contact-email-comprar':
            value = EMAIL_REGEX.test(String(elValue).toLowerCase());
            value = value && document.getElementById('lead_optin_email').checked
            contactData['email'] = elValue;
            break;

          case 'contact-phone':
            value = elValue.length >= 14 ? true : false;
            ['terrain_optin_tel', 'terrain_optin_sms', 'terrain_optin_whatsapp'].forEach(elem => {
              value = value && document.getElementById(elem).checked
            });

            contactData['phone'] = elValue;
            break;

          case 'contact-phone-comprar':
            value = elValue.length >= 14 ? true : false;
            ['lead_optin_tel', 'lead_optin_sms', 'lead_optin_whatsapp'].forEach(elem => {
              value = value && document.getElementById(elem).checked
            });

            contactData['phone'] = elValue;
            break;


          case 'contact-region':
            value = parseInt(elValue) > 0 ? true : false;
            contactData['region'] = elValue;
            break;

          case 'area-terreno':
            value = parseInt(elValue) >= 2000 ? true : false;
            contactData['area'] = elValue;
            break;

          case 'cep':
            value = elValue.length >= 9 ? true : false;
            console.log('CEP >>> Request Data ---- ', value);
            document.getElementById('cep-error').style.display = 'none';
            contactData['zipcode'] = elValue;
            break;

          case 'enviar-link-maps':
            value = elValue.length ? true : false;
            contactData['maps_url'] = elValue;
            break;
        }
        // console.log('ContactData UPDATED ::', contactData);

        return value;
      }

      const nextScreen = () => {
        self.goToStepIndex ? changeScreen(self.goToStepIndex) : changeScreen(self.index + 1);
      }

      self.init = () => {
        // console.log(`Step ${self.index} :: INITIALIZATION :: Single Input Controller`, document.getElementById(self.elementId));

        setTimeout(() => document.getElementById(self.elementId).focus(), 250);

        nextButton.disabled = !isValid();
        self.element.addEventListener('keyup', keyUpHandler);
      }

      self.nextStep = async () => {

        if (isValid()) {
          if (self.elementId == 'contact-email-comprar' || self.elementId == 'contact-email') {
            document.body.classList.add('changing-chat-screen', 'is-loading')

            let validationEmail = await validateEmail(self.element.value);
            let span = document.getElementById(`contact-error-${self.elementId}`);

            if (validationEmail) {
              nextScreen()
              span.style.display = 'none'
              setTimeout(() => {
                document.body.classList.remove('changing-chat-screen', 'is-loading');
              }, 250);
            } else {
              span.style.display = 'block'
              span.innerText = 'Por favor, digite um e-mail válido!'
              document.body.classList.remove('changing-chat-screen', 'is-loading')
              return;
            }

            // console.log(res)
          }

          if (self.elementId == 'contact-phone-comprar' && product_id == null) {
            document.body.classList.add('changing-chat-screen', 'is-loading');

            let validationPhone = await validatePhone(self.element.value);
            let span = document.getElementById(`contact-error-${self.elementId}`);

            if (validationPhone) {
              nextScreen()
              span.style.display = 'none'
              setTimeout(() => {
                document.body.classList.remove('changing-chat-screen', 'is-loading');
              }, 250);
            } else {
              span.style.display = 'block'
              span.innerText = 'Por favor, digite um número de celular válido!'
              document.body.classList.remove('changing-chat-screen', 'is-loading')
              return;
            }
          }

          if ((self.elementId == 'contact-phone') ||
            (self.elementId == 'contact-region') ||
            ((product_id != null) && (self.elementId == 'contact-phone-comprar'))

          ) {
            document.body.classList.add('changing-chat-screen', 'is-loading');

            let validationPhone = await validatePhone(self.element.value);
            let span = document.getElementById(`contact-error-${self.elementId}`);

            if (validationPhone) {
              span.style.display = 'none'
              postLead(contactData, nextScreen);
            } else {
              span.style.display = 'block'
              span.innerText = 'Por favor, digite um número de celular válido!'
              document.body.classList.remove('changing-chat-screen', 'is-loading');
              return;
            }

            //nextScreen();
          }

          else if (self.elementId == 'cep') {
            let code = document.getElementById(self.elementId).value;
            jsonp(`https://viacep.com.br/ws/${code}/json`, null, (err, responseData) => {
              if (responseData) {

                // console.log('CEP Response :: ', responseData);
                if (responseData.erro) {
                  document.getElementById('cep-error').style.display = 'block';
                  return;
                }

                contactData["neighborhood"] = responseData.bairro;
                contactData["city"] = responseData.localidade;
                contactData["uf"] = responseData.uf;

                nextScreen();

              } else if (err) {
                console.log('Error :: ', err);
              }
            })
          }
          else {
            nextScreen();
          }
        }
      }


      self.dispose = () => {
        // console.log(`Step ${self.index} :: DISPOSE :: Single Input Controller`);
        self.element.removeEventListener('keyup', keyUpHandler);
        document.getElementById(self.elementId).blur()
      }
    }

    function ButtonController(index, element, goToStepIndex) {

      let self = this;
      self.index = index;
      self.element = element;
      self.elementId = element.id;
      self.goToStepIndex = goToStepIndex;

      const clickHandler = (event) => {
        console.log('Button Click >>> ', self.elementId);
        if (self.elementId == 'sou-proprietario' || self.elementId == 'sou-representante') {
          contactData['owner'] = self.elementId == 'sou-proprietario';
        }


        console.log("2")
        event.target.parentElement.parentElement.dataset.buttonId = self.elementId;
        self.nextStep()
      }

      self.init = () => {
        console.log(`Step ${self.index} :: INITIALIZATION :: ButtonController`);
        self.element.addEventListener('click', clickHandler);

      }

      self.nextStep = () => {
        changeScreen(self.goToStepIndex, self.elementId);
      }

      self.dispose = () => {
        // console.log(`Step ${self.index} :: DISPOSE :: ButtonController`);
        self.element.removeEventListener('click', clickHandler)
      }
    }


    function SelectController(index, element, goToStepIndex) {

      let self = this;
      self.index = index;
      self.element = element;
      self.elementId = element.id;
      self.goToStepIndex = goToStepIndex;

      const changeHandler = (event) => {
        console.log("changeHandler")
        nextButton.disabled = !isValid();

        //event.target.parentElement.parentElement.dataset.buttonId = self.elementId;
        //self.nextStep();
      }

      const isValid = () => {
        let value = false;
        let select = document.getElementById(self.elementId);

        switch (self.elementId) {
          case 'contact-region':
            contactData['regionId'] = select.value;
            contactData['region'] = select.options[select.selectedIndex].text;

            console.log(select.value);

            return (select.value >= 0);
        }

        return true;
      }

      self.init = () => {
        let select = document.getElementById(self.elementId);

        $('#' + self.elementId).on("change", changeHandler);

        nextButton.disabled = !isValid();
      }

      self.nextStep = () => {

        if (isValid()) {

          if (self.elementId == 'contact-region') {
            postLead(contactData, nextScreen);
            document.body.classList.add('changing-chat-screen', 'is-loading');
          }
          else {
            document.body.classList.remove('changing-chat-screen', 'is-loading');
          }

          //nextScreen();
        }

      }

      self.dispose = () => {
        self.element.removeEventListener('change', changeHandler)
      }

      const nextScreen = () => {
        self.goToStepIndex ? changeScreen(self.goToStepIndex) : changeScreen(self.index + 1);
      }
    }

    function FileSelectorController(index, element, senderButtonId) {

      let self = this;
      self.index = index;
      self.element = element;
      self.elementId = element.id;
      self.senderButtonId = senderButtonId;
      self.buttonLabel = document.getElementById(self.senderButtonId).value;

      // console.log('>>> Button Label : ', self.buttonLabel);

      const resetButtons = () => {
        document.getElementById('label-' + self.elementId).classList.remove('is-files');
        document.getElementById(self.senderButtonId).disabled = true;
        setTimeout(() => {
          document.getElementById(self.elementId).disabled = false;
        }, 100);
      }

      const onClickIndexFileHandler = event => {
        const index = parseInt(event.currentTarget.dataset.index) - 1;
        let newFiles = [];

        Object.keys(selectedFiles).map(key => {
          if (key != index) newFiles.push(selectedFiles[key]);
        });

        self.element.files = new FileListItem(newFiles);

        onFileSelectorChangeHandler();
      }

      const onFileSelectorChangeHandler = event => {

        // console.log('>>>>> File CHANGED ---- ');

        selectedFiles = event ? event.target.files : self.element.files;

        document.querySelector(`#${self.senderButtonId} .btn-label`).innerHTML = self.buttonLabel;

        let totalObjects = Object.keys(selectedFiles).length;

        if (totalObjects > 0) {
          document.getElementById('label-' + self.elementId).classList.add('is-files');
          document.getElementById(self.elementId).disabled = true;
          document.getElementById(self.senderButtonId).disabled = false;
        } else {
          resetButtons();
        }

        for (let index = 1; index <= 5; index++) {
          const displayValue = (index <= totalObjects) ? 'block' : 'none';
          const fileIndexElement = document.getElementsByClassName(`${self.elementId}-file-index-${index}`)[0];
          const fileIndexName = document.getElementsByClassName(`${self.elementId}__tooltip-${index}`)[0];
          const onlyFileName = document.getElementById('only-file');

          if (fileIndexElement) {
            fileIndexElement.style.display = displayValue;
            fileIndexName.innerHTML = (index <= totalObjects) ? selectedFiles[index - 1].name : '';

            if (onlyFileName && selectedFiles.length) {
              onlyFileName.innerHTML = selectedFiles[0].name;
            }
          }
        }
      }

      self.init = () => {
        self.element.addEventListener('change', onFileSelectorChangeHandler)
        for (let index = 1; index <= 5; index++) {
          const fileIndexElement = document.getElementsByClassName(`${self.elementId}-file-index-${index}`)[0];
          if (fileIndexElement) fileIndexElement.addEventListener('click', onClickIndexFileHandler);
        }
      }

      self.dispose = () => {
        self.element.removeEventListener('change', onFileSelectorChangeHandler)
        resetButtons();
      }
    }

    function FilesSenderController(index, element, filePrefix, goToStepIndex, selectButtonId) {

      let self = this;
      self.index = index;
      self.element = element;
      self.elementId = element.id;
      self.selectButtonId = selectButtonId;
      self.filePrefix = filePrefix;
      self.goToStepIndex = goToStepIndex;

      self.init = () => {
        self.element.addEventListener('click', event => {
          let endpoint = '';
          let formData = new FormData();
          const objKeys = Object.keys(selectedFiles);
          const buttonId = event.currentTarget.parentElement.parentElement.dataset.buttonId;

          switch (buttonId) {
            case 'sou-corretor':
              endpoint = '/realtor'
              break;
            case 'outro-setor':
              endpoint = '/workwithus'
              break;
            default:
              endpoint = '/terrain'
              break;
          }

          if (objKeys.length) {
            if (self.selectButtonId) document.getElementById(self.selectButtonId).disabled = true;

            if (endpoint == '/terrain') {
              objKeys.map(key => {
                formData.append(`${self.filePrefix}[${key}]`, selectedFiles[key])
              })
            } else {
              formData.append(self.filePrefix, selectedFiles[0])
            }
          }

          // Base Data + File Data Concat
          updateFormData(formData, contactData);
          // Endpoint Request
          postRequest(
            endpoint,
            formData,
            () => { changeScreen(goToStepIndex) },
            true,
            self.elementId)
            ;
          // Add Loading
          document.body.classList.add('changing-chat-screen', 'is-loading')

          switch (self.elementId) {
            case 'enviar-cv':
              document.getElementById('enviar-cv').disabled = true;
              break;
            case 'enviar-imagens':
              document.getElementById('enviar-imagens').disabled = true;
              document.getElementById('nao-possui-imagem').disabled = true;
              break;
          }
        })
      }

      self.dispose = () => {
        // Remove Loading
        document.body.classList.remove('changing-chat-screen', 'is-loading')
      }
    }


    function RedirectUrlController(index, element, url, isBlank) {
      // console.log('URL Controller : ', index);
      element.addEventListener('click', e => {
        window.open('http://parceriascury.housecrm.com.br/parceiro/', '_blank');
        window.location = '/';
      })
    }

    function ChatController(index, element) {
      // console.log('Step Controller : ', index);
    }
  })

  const updateFormData = (formData, objectData) => (
    Object.keys(objectData).map(key => {
      formData.append(key, objectData[key]);
    })
  )

  const extractDDD = (phone) => {
    let regExp = /\(([^)]+)\)/;
    let dddNumber = regExp.exec(phone)[1];
    return dddNumber;
  }

  const extractPhone = (phone) => {
    let phoneNumber = phone.split(')')[1];
    return phoneNumber;
  }

  const postRequest = (endpoint, data, callBackFn, isFormData, elementId) => {

    const prefix = endpoint === '/terrain' ? 'terrain' : 'lead';
    const optins = {
      tel: document.getElementById(`${prefix}_optin_tel`).checked ? 1 : 0,
      sms: document.getElementById(`${prefix}_optin_sms`).checked ? 1 : 0,
      whatsapp: document.getElementById(`${prefix}_optin_whatsapp`).checked ? 1 : 0,
      email: document.getElementById(`${prefix}_optin_email`).checked ? 1 : 0
    };

    if (isFormData) {
      if (!data.get("uf")) data.append("uf", window.state);
      data.append("optin_tel", optins.tel);
      data.append("optin_sms", optins.sms);
      data.append("optin_whatsapp", optins.whatsapp);
      data.append("optin_email", optins.email);
    } else {
      if (!data.uf) data["uf"] = window.state;
      data["optin_tel"] = optins.tel;
      data["optin_sms"] = optins.sms;
      data["optin_whatsapp"] = optins.whatsapp;
      data["optin_email"] = optins.email;
    }

    axios.post(`${API_PATH}${endpoint}`,
      data, {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
      },
      onUploadProgress: function (progressEvent) {
        if (elementId && elementId != 'nao-possui-imagem') {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          let percentage = `${this.uploadPercentage}%`;
          document.querySelector(`#${elementId} .btn-label`).innerHTML = percentage;
          document.querySelector(`#${elementId} .loader-bar`).style.width = percentage;
        }
      }
    }).then(function (response) {
      if (response.data.success && callBackFn) {
        try {
          contactData.uf = response.data.data.uf;
          contactData.product_name = response.data.data.product_name;
          contactData.chat_url = response.data.chat_url;
        } catch (e) {
          contactData.uf = '';
          contactData.product_name = '';
          contactData.chat_url = '';
        }

        callBackFn(response.data);
      } else {
        console.log('>>>> FAIL - ', response.data.message)
      }

    })
      .catch(function (err) {
        console.log('erro:', err);
        alert('Ocorreu algum erro ao processar os dados. Teste novamente mais tarde.');
      });
  }


  async function postLead(contactData, continueCallback) {

    contactData['origin'] = 'Contact/Chat';

    postRequest('/lead', contactData, (response) => {

      contactData['lead_id'] = response.data.id;
      contactData['chat_url'] = response.data.chat_url;

      let clientName = response.data.client_name;
      let clientCode = response.data.client_validate_code;

      document.querySelector('.contact-user-name').innerHTML = clientName;
      document.querySelector('.contact-user-code').innerHTML = clientCode;

      document.body.classList.remove('changing-chat-screen', 'is-loading');
      continueCallback();

    }, false);
  }
})();